import { Component, EventEmitter, forwardRef, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { ControlContainer, NgForm, NgModelGroup } from '@angular/forms';
import * as _ from 'lodash';
import { EnderecoService } from 'src/app/services/endereco/endereco.service';

@Component({
  selector: 'combo-uf',
  templateUrl: './combo-uf.component.html',
  styleUrls: ['./combo-uf.component.css'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm },
                  { provide: ControlContainer, useExisting: forwardRef(() => NgModelGroup) }],
})
export class ComboUfComponent implements OnInit {

  @ViewChild('comboUf', {static: false}) comboUf;

  @Input() showDisplayId;
  @Input() obrigatorio;
  @Input() selecionado;
  @Input() desabilitado;

  @Output() valorChange = new EventEmitter();

  dados = [];
  data: any = {};

  constructor(private enderecoService: EnderecoService) {
  }

  ngOnInit(): void {
    this.data = Date.now();

    this.enderecoService.getAllEstados().subscribe((ufs: any) => {
      this.dados = ufs.map((uf: string, index: number) => ({
        id: index + 1,
        nome: uf
      }));
      this.preencherCombo();
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.preencherCombo();
  }

  private preencherCombo(){
    if (this.selecionado && this.dados.length) {
      if (typeof this.selecionado === 'string') {
        this.selecionado = _.find(this.dados, { nome: this.selecionado});
      }
    }
  }

  onValorChange(registro: any) {
    this.valorChange.emit(registro);
    this.preencherCombo();
  }

}
